<img
  *ngIf="status == 'C'"
  class="cancel"
  src="../../../assets/icon/cancelled OP40_0.png"
  alt=""
/>
